import { ConfigurationLabel, ConfigurationLabelValue } from 'src/common/types/ConfigurationTypes';

import { Label, LabelType } from '../../pages/label-management/types';

const mapValueToString = (value: string | ConfigurationLabelValue): string =>
	typeof value === 'string' ? value : value.value;

const mapConfigLabelToLabel = (configLabel: ConfigurationLabel, type: LabelType): Label => ({
	key: configLabel.label,
	displayName: configLabel.displayName ?? configLabel.label,
	type,
	values: configLabel.values.map(mapValueToString)
});

export const mapPlatformLabels = (
	coreLabels: ConfigurationLabel[],
	additionalLabels: ConfigurationLabel[]
): Label[] => [
	...coreLabels.map((l) => mapConfigLabelToLabel(l, LabelType.CORE)),
	...additionalLabels.map((l) => mapConfigLabelToLabel(l, LabelType.CUSTOM))
];
